import { PixiContext } from "common/pixi";
import { createApplication, createCenterContainer } from "common/pixi/app";
import { ReesizeEventHandler } from "common/resize";
import { Black } from "common/sprites/black";
import * as PIXI from "pixi.js";
import { Background, Button, Hand, loadSheets, Message, Title, } from "third-animation/scene/resources";
import { letterbox } from "third-animation/screen";
import * as LoadingAnimation from "./loadingAnimation";
import * as TypeInteraction from "./typeInteraction";
export class Scene {
    async start({ sound, parentSelector, }) {
        console.log("start scene");
        const resizer = new ReesizeEventHandler();
        letterbox(resizer);
        const app = createApplication(parentSelector);
        const sheets = await loadSheets();
        const pixiContext = new PixiContext(app);
        const ticker = pixiContext.ticker;
        ticker.speed = 1;
        const elements = loadAllElements({ sheets, app, pixiContext });
        addElementsToScene({ elements, app });
        await LoadingAnimation.run({ elements, sound, pixiContext });
        await TypeInteraction.run({ elements, sound, pixiContext });
        pixiContext.dispose();
        app.destroy(true);
        PIXI.utils.destroyTextureCache();
        $("#pixi-canvas").remove();
        resizer.drop();
    }
}
function loadAllElements({ sheets, app, pixiContext, }) {
    return {
        background: new Background(pixiContext, sheets),
        button: new Button(pixiContext, sheets),
        black: new Black(app),
        message: new Message(pixiContext, sheets),
        title: new Title(pixiContext, sheets),
        hand: new Hand(sheets),
    };
}
function addElementsToScene({ elements: { background, button, black, message, title, hand }, app, }) {
    const centerContainer = createCenterContainer();
    app.stage.addChild(centerContainer);
    const pixiObjects = [
        background.sprite,
        message.sprite,
        hand.sprite,
        title.sprite,
        button.sprite,
        black.sprite,
    ];
    for (const pixiObject of pixiObjects) {
        centerContainer.addChild(pixiObject);
        pixiObject.visible = false;
    }
}
//# sourceMappingURL=main.js.map